/* eslint-disable max-len */
import { usersList } from "./apiSlice";

const otpPreferenceList = usersList.injectEndpoints({
    tagTypes: ['preference',],
    endpoints: (builder) => ({
        getOtpPreferenceList: builder.query({
            query: (searchParams) => ({
                url: `users/preference/${searchParams}`,
                method: 'GET',
               
            }),
        }),
        deleteOtpPreference: builder.mutation({
            query: (id) => ({
                url: `users/preference/${id}`,  // `id` is the actual value here
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'preference', id: arg }]
        }),
    }),
   
    overrideExisting: false
})


export const {
    useGetOtpPreferenceListQuery,
    useGetProviderReportListQuery,
    useDeleteOtpPreferenceMutation

} = otpPreferenceList